import React, { useState } from 'react'
import SideDrawer from '../../../../Components/sideDrower/SideDrawer'
import { LoadingButton } from '../../../../Components/header/form'
import { reportApi } from '../../../../services/report';
import { toastMessage } from '../../../../utils/toastMessage';

const OverviewReport = ({ show, close, id, selectedData = '', pageName = 'Group', type }) => {
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState({});
    // console.log('id', id)
    // OnChange handler
    const inputChangeHandler = (e) => {
        const { name, value } = e.target;
        setReportData({ ...reportData, [name]: value });
    };
    //-------modal-close-----------
    const closeModal = () => {
        close()
        setReportData({})
    }
    //----------------send-report----------------------
    const sendReportHandler = async () => {
        if (!reportData?.title?.trim()) {
            toastMessage("Report cannot be empty!", "error", "report");
            return;
        }
        try {
            setLoading(true);
            const { data } = await reportApi({
                // _report: selectedData?._group?._id,
                _report: id || selectedData?._id,
                ...reportData,
                description: reportData?.description || reportData?.title,
                type: type || 'FEED'
            });
            const { success, message, data: response } = data;
            toastMessage(message, success ? "success" : "error", "reportHandler");
            if (success) {
                closeModal()
            }
        } catch (e) {
            console.log(e.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <SideDrawer show={show} handleClose={closeModal}>
            <div className="report_heading">
                <h2>Report {pageName}</h2>

                <hr className="horizontal_line" />

                <p>
                    Please provide a reason for reporting this {pageName}. Our team will review
                    your report and take appropriate action if necessary.
                </p>
            </div>

            <div className="report_form">
                <div className="form_header">
                    <h2 className="form_title">Select Reason</h2>
                </div>

                <form className="radio_group">
                    <div className="radio_option">
                        <input
                            type="radio"
                            id="inappropriate"
                            name="title"
                            value="inappropriate"
                            checked={reportData?.title === "inappropriate"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="inappropriate">Inappropriate Content</label>
                    </div>

                    <div className="radio_option">
                        <input
                            type="radio"
                            id="spam"
                            name="title"
                            value="spam"
                            checked={reportData?.title === "spam"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="spam">Spam or Scams</label>
                    </div>

                    <div className="radio_option">
                        <input
                            type="radio"
                            id="harassment"
                            name="title"
                            value="harassment"
                            checked={reportData?.title === "harassment"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="harassment">Harassment or Bullying</label>
                    </div>

                    <div className="radio_option">
                        <input
                            type="radio"
                            id="hate"
                            name="title"
                            value="hate"
                            checked={reportData?.title === "hate"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="hate">Hate Speech or Symbols</label>
                    </div>

                    <div className="radio_option">
                        <input
                            type="radio"
                            id="violence"
                            name="title"
                            value="violence"
                            checked={reportData?.title === "violence"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="violence">Violence or Harm</label>
                    </div>

                    <div className="radio_option">
                        <input
                            type="radio"
                            id="copyright"
                            name="title"
                            value="copyright"
                            checked={reportData?.title === "copyright"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="copyright">Copyright Violation</label>
                    </div>

                    <div className="radio_option">
                        <input
                            type="radio"
                            id="other"
                            name="title"
                            value="other"
                            checked={reportData?.title === "other"}
                            onChange={inputChangeHandler}
                        />
                        <label htmlFor="other">Other</label>
                    </div>
                </form>
                {reportData?.title === "other" && (
                    <>
                        <div className="form_header">
                            <h2 className="form_title">Additional Comments</h2>
                        </div>

                        <div className="textarea_report">
                            <textarea
                                name="description"
                                id="description"
                                rows="6"
                                cols="40"
                                onChange={inputChangeHandler}
                            />
                        </div>
                    </>
                )}

                <LoadingButton
                    loading={loading}
                    onClick={sendReportHandler}
                    className="btn"
                    type="submit"
                    value="Submit"
                >
                    Submit Report
                </LoadingButton>
            </div>
        </SideDrawer>
    )
}

export default OverviewReport